export const NAV_COMMUNITY = { fr: 'Communauté', en: 'Community', de: 'Community', es: 'Comunidad', pt: 'Comunidade' };
export const NAV_CREATORS = { fr: 'Créateurs', en: 'Creators', de: 'Ersteller', es: 'Creadores', pt: 'Criadores' };

export function navLabel(dict, lang) {
    return dict[lang] || dict.en;
}
